<template>
  <i-box>
    <span slot="title">
      <span class="pull-right text-muted count">
        <em>n</em>
        ={{ totalRespondents }}
      </span>
      <h3>{{ title }}</h3>
      <div class="clearfix"></div>
    </span>
    <span slot="heading">{{ heading }}</span>
    <span slot="content" v-if="profileCharts && Object.keys(profileCharts).length > 0">
      <div
        class="row"
        v-for="i in Math.ceil(Object.keys(profileCharts).length / itemsPerRow)"
        :key="i"
      >
        <div
          class="col-lg-3"
          v-for="key in Object.keys(profileCharts).sort().slice((i - 1) * itemsPerRow, i * itemsPerRow)"
          :key="key"
        >
          <h4>{{ capitalise(key) }}</h4>
          <!--<div v-if="key === 'gender'">-->
          <div v-if="false">
            <div class="gender-respondents">
              <div class="gender-block">
                <div @click="handleGenderClicked($event, 'Gender', genderItem('Male'))">
                  <i
                    class="fa fa-fw fa-male"
                    :style="{color: generateTitleColor('male', hueRange)}"
                  ></i>
                </div>
                <div class="gender-percentage">{{ profileGender('Male') }}</div>
              </div>
              <div class="gender-block">
                <div @click="handleGenderClicked($event, 'Gender', genderItem('Female'))">
                  <i
                    class="fa fa-fw fa-female"
                    :style="{color: generateTitleColor('female', hueRange)}"
                  ></i>
                </div>
                <div class="gender-percentage">{{ profileGender('Female') }}</div>
              </div>
            </div>
            <chart-legend
              :data="[['Male', profileGender('Male')], ['Female', profileGender('Female')]]"
              :colorCycle="[generateTitleColor('male', hueRange), generateTitleColor('female', hueRange)]"
            />
          </div>
          <!-- <div v-if="key !== 'gender'"> -->
          <div v-if="true">
            <div style="height: 155px;">
              <pie-chart
                :height="155"
                :colorCycle="generateColorPool(totalDisplay(profileCharts[key]), hueRange)"
                :data="totalDisplay(profileCharts[key])"
                :options="pieChartOptions"
                @onClick="handleProfileClicked($event, key, profileCharts[key])"
              />
            </div>
            <chart-legend
              :data="totalDisplay(profileCharts[key])"
              :colorCycle="generateColorPool(totalDisplay(profileCharts[key]), hueRange)"
              :isPercentage="selectedTotalDisplay === 'percentage'"
            />
          </div>
        </div>
      </div>
    </span>
    <span slot="content" v-else>
      <empty>No respondents found.</empty>
    </span>
  </i-box>
</template>

<script>
import colorMixin from '@/mixins/colors';
import IBox from '@/components/common/IBox';
import Empty from '@/components/common/Empty';
import BarChart from '@/components/charts/BarChart';
import PieChart from '@/components/charts/PieChart';
import ChartLegend from '@/components/charts/ChartLegend';

export default {
  mixins: [colorMixin],
  components: {
    IBox,
    Empty,
    BarChart,
    PieChart,
    ChartLegend,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    heading: {
      type: String,
      required: true,
    },
    profileCharts: {
      type: Object,
      required: true,
    },
    totalRespondents: {
      type: Number,
      default: 0,
    },
    selectedTotalDisplay: {
      type: String,
      default: 'percentage',
    },
    hueRange: {
      type: Array,
      default: () => [0, 359],
    },
  },
  data: () => ({
    itemsPerRow: 4,
  }),
  computed: {
    profileGender() {
      // If our data hasn't populated yet, just return 0 as the percentage for now.
      if (Object.keys(this.profileCharts).indexOf('gender') < 0) {
        return () => 0;
      }

      const total = this.profileCharts.gender.reduce(
        (a, b) => a[this.selectedTotalDisplay] + b[this.selectedTotalDisplay],
      );

      const formatMap = {
        percentage: (c, t) => `${Math.round((c / t) * 100)}%`,
        total: c => c.toLocaleString(),
        cume: c => c.toLocaleString(),
      };

      return gender => {
        const count = this.profileCharts.gender.filter(g => g.title === gender)[0][
          this.selectedTotalDisplay
        ];
        const format = formatMap[this.selectedTotalDisplay](count, total);
        return format;
      };
    },

    genderItem() {
      return gender => this.profileCharts.gender.filter(g => g.title === gender)[0];
    },

    pieChartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generatePieTooltipLabel,
          },
        },
      };
    },
  },
  methods: {
    handleProfileClicked(event, title, profileItem) {
      this.$emit('onProfileClicked', event, title, profileItem);
    },

    totalDisplay(answers) {
      return Array.isArray(answers)
        ? answers.map(a => [a.title, a[this.selectedTotalDisplay]])
        : [];
    },

    handleGenderClicked(event, title, answer) {
      this.$emit('onGenderClicked', event, title, answer);
    },

    generateTooltipLabel(tooltipItem, data) {
      const label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || '';

      const formatMap = {
        percentage: l => `${l}%`,
        total: l => l.toLocaleString(),
        cume: l => l.toLocaleString(),
      };

      return formatMap[this.selectedTotalDisplay](label);
    },

    generatePieTooltipLabel(tooltipItem, data) {
      const total = this.generateTooltipLabel(tooltipItem, data);
      const label = data.labels[tooltipItem.index];

      return `${label}: ${total}`;
    },
    capitalise(content) {
      return content
        .split('_')
        .map(x => `${x[0].toUpperCase()}${x.slice(1)}`)
        .join(' ');
    },
  },
};
</script>

<style lang="scss" scoped>
.gender-respondents {
  min-width: 210px;
  height: 155px;

  .gender-block {
    display: inline-block;
    text-align: center;
  }
  .fa {
    margin-top: 14px;
    font-size: 80px;
  }
  .fa-male {
    color: #2da1d8;
  }
  .fa-female {
    color: #e132c7;
  }
  .gender-percentage {
    margin-top: 12px;
    font-size: 1.2em;
  }
}
</style>



// WEBPACK FOOTER //
// RespondentProfileChart.vue?8cf33940